import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ItemsList, Pagination } from "@parkschannel/ui";
import { useScrollTo } from "../../../utils";
import { ParkCardWithSticker } from "../ParkCard";
export const ParksList = (param)=>{
    let { pagination , data  } = param;
    const { scrollTo  } = useScrollTo({
        id: "parks-videos-section"
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ItemsList, {
                className: "w-full py-6 grid gap-4 grid-cols-1 md:gap-6 md:grid-cols-2 xl:grid-cols-3",
                noItemsMessage: "Parks not found",
                items: data,
                renderItem: (park)=>/*#__PURE__*/ _jsx(ParkCardWithSticker, {
                        data: park
                    })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-full flex justify-end",
                children: /*#__PURE__*/ _jsx(Pagination, {
                    pagination: pagination,
                    onPageChange: scrollTo
                })
            })
        ]
    });
};
